import { call, put, takeLatest, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { SYNC_CONTENTFUL_DATA, SYNC_CONTENTFUL_DATA_SUCCESS, SYNC_CONTENTFUL_DATA_FAILURE, CONTENTFUL_ENTRY, CONTENTFUL_ENTRY_SUCCESS, CONTENTFUL_ENTRY_FAILURE, } from '../constants';
const sysId = 'sys.id';
const sysContentTypeId = 'sys.contentType.sys.id';
const contentType = {
    HOME: 'home',
    MORE: 'more',
};
const moreContentFieldsType = {
    FOOTER: 'footer',
    HEADER: 'header',
    LOGO: 'logo',
    NAVIGATION_TRAY: 'navigationTray',
    TENANT: 'tenant',
};
const HomeContentFieldType = {
    CRMSIGNUP: 'crmSignUp',
    MARKETING_CAROUSAL: 'carousalComponent',
    DISPOSITION: 'disposition',
    ROUTING: 'routingComponent',
};
export function* syncContentCall(data) {
    try {
        const homeContentData = yield select((state) => state.contentReducer);
        const moreContentData = yield select((state) => state.moreReducer);
        const { payload } = data;
        if (homeContentData?.contentfulSyncData?.nextSyncToken) {
            payload.syncObj = {
                nextSyncToken: homeContentData?.contentfulSyncData?.nextSyncToken,
            };
        }
        const response = yield call(payload.object.sync, payload.syncObj);
        if (response) {
            yield put({
                type: SYNC_CONTENTFUL_DATA_SUCCESS,
                response,
            });
            if (homeContentData?.contentfulSyncData?.nextSyncToken &&
                homeContentData?.response?.homeContentfulResp &&
                moreContentData?.response) {
                const homeSyncIds = yield needsHomeScreenRefresh(response, homeContentData.response);
                const moreSyncIds = yield needsMoreScreenRefresh(response, moreContentData.response);
                const contentClient = Object.assign({}, payload?.object);
                yield put({
                    type: CONTENTFUL_ENTRY,
                    homeSyncIds,
                    moreSyncIds,
                    contentClient, // contentful object
                });
            }
        }
        else {
            yield put({
                type: SYNC_CONTENTFUL_DATA_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: SYNC_CONTENTFUL_DATA_FAILURE,
        });
    }
}
export function* syncContentSaga() {
    yield takeLatest(SYNC_CONTENTFUL_DATA, syncContentCall);
}
export const needsHomeScreenRefresh = (syncObject = null, response = null) => {
    const type = contentType.HOME;
    const syncIdsListObj = {};
    if (!response?.homeContentfulResp?.length) {
        return syncIdsListObj;
    }
    // ALSO consider
    if (syncObject && response) {
        // entries
        syncObject?.entries?.forEach((entry) => {
            // check if the whole home content has been changed at root level. Exit with result
            if (response?.rootSysId && response?.rootSysId === get(entry, sysId)) {
                syncIdsListObj.type = type;
                syncIdsListObj.syncList = [{ id: response?.rootSysId, index: -1 }];
                return syncIdsListObj;
            }
            for (let j = 0; j < response.homeContentfulResp.length; j++) {
                const homeContentfulObj = response.homeContentfulResp[j];
                const matchingId = findMatchingContentfulIds(entry, homeContentfulObj, true);
                if (matchingId) {
                    if (syncIdsListObj?.type) {
                        syncIdsListObj.syncList.push({ id: matchingId, index: j });
                    }
                    else {
                        syncIdsListObj.type = type;
                        syncIdsListObj.syncList = [{ id: matchingId, index: j }];
                    }
                }
            }
        });
    }
    return syncIdsListObj;
};
export const findMatchingContentfulIds = (syncObject, localContentfulObj, needsCustomFieldsToBeInspected = false) => {
    const syncSysId = get(syncObject, sysId);
    const homeSysId = get(localContentfulObj, sysId);
    if (syncSysId === homeSysId) {
        return homeSysId;
    }
    if (!needsCustomFieldsToBeInspected) {
        return null;
    }
    else {
        // This check is only for home contentful objects where we need to check internal custom fields for sys ids like Routing Component, Marketing Hero etc
        // Need not consider OrderServ contentType components
        // General Routing
        if (get(localContentfulObj, sysContentTypeId) === HomeContentFieldType.ROUTING) {
            for (let i = 0; i < localContentfulObj?.fields?.routingContent?.length; i++) {
                const routingComponent = localContentfulObj.fields.routingContent[i];
                if (get(routingComponent, sysId) === syncSysId) {
                    return homeSysId;
                }
            }
        } // Disposition
        else if (get(localContentfulObj, sysContentTypeId) === HomeContentFieldType.DISPOSITION) {
            for (let i = 0; i < localContentfulObj?.fields?.headline?.length; i++) {
                const routingComponent = localContentfulObj.fields.headline[i];
                if (get(routingComponent, sysId) === syncSysId) {
                    return homeSysId;
                }
            }
            for (let i = 0; i < localContentfulObj?.fields?.supportedDispositions?.length; i++) {
                const routingComponent = localContentfulObj.fields.supportedDispositions[i];
                if (get(routingComponent, sysId) === syncSysId) {
                    return homeSysId;
                }
            }
        }
        // Marketing Hero
        else if (get(localContentfulObj, sysContentTypeId) === HomeContentFieldType.MARKETING_CAROUSAL) {
            for (let i = 0; i < localContentfulObj?.fields?.carousalContent?.length; i++) {
                const routingComponent = localContentfulObj.fields.carousalContent[i];
                if (get(routingComponent, sysId) === syncSysId) {
                    return homeSysId;
                }
            }
        } // CRM Sign up
        else if (get(localContentfulObj, sysContentTypeId) === HomeContentFieldType.CRMSIGNUP) {
            const crmFields = localContentfulObj?.fields;
            if (get(crmFields?.DesktopImage, sysId) === syncSysId) {
                return homeSysId;
            }
            else if (get(crmFields?.button, sysId) === syncSysId) {
                return homeSysId;
            }
            else if (get(crmFields?.mobileImage, sysId) === syncSysId) {
                return homeSysId;
            }
        }
    }
    return null;
};
export const needsMoreScreenRefresh = (syncObject = null, response = null) => {
    const type = contentType.MORE;
    const syncIdsListObj = {};
    if (!response) {
        return syncIdsListObj;
    }
    if (syncObject && response) {
        // entries
        for (let i = 0; i < syncObject?.entries?.length; i++) {
            const entry = syncObject.entries[i];
            // check if the whole home content has been changed at root level. Exit with result
            if (response?.rootSysId && response?.rootSysId === get(entry, sysId)) {
                syncIdsListObj.type = type;
                syncIdsListObj.syncList = [{ id: response?.rootSysId, indexObj: '' }];
                return syncIdsListObj;
            }
            if (response?.moreContent?.fields) {
                let moreContentfulObj = response.moreContent.fields;
                if (moreContentfulObj?.footer) {
                    const footerContent = moreContentfulObj.footer;
                    prepareMoreContentSyncList(syncIdsListObj, entry, footerContent, moreContentFieldsType.FOOTER);
                }
                if (moreContentfulObj?.header) {
                    const headerContent = moreContentfulObj.header;
                    prepareMoreContentSyncList(syncIdsListObj, entry, headerContent, moreContentFieldsType.HEADER);
                }
                if (moreContentfulObj?.logo) {
                    const logoContent = moreContentfulObj.logo;
                    prepareMoreContentSyncList(syncIdsListObj, entry, logoContent, moreContentFieldsType.LOGO);
                }
                if (moreContentfulObj?.navigationTray) {
                    const tabContent = moreContentfulObj.navigationTray;
                    prepareMoreContentSyncList(syncIdsListObj, entry, tabContent, moreContentFieldsType.NAVIGATION_TRAY);
                }
            }
        }
    }
    return syncIdsListObj;
};
export const prepareMoreContentSyncList = (syncIdsListObj, entry, moreContentfulObj, moreContentFieldsType) => {
    const type = contentType.MORE;
    const matchingId = findMatchingContentfulIds(entry, moreContentfulObj);
    if (matchingId) {
        if (syncIdsListObj?.type) {
            syncIdsListObj.syncList.push({
                id: matchingId,
                indexObj: moreContentFieldsType,
            });
        }
        else {
            syncIdsListObj.type = type;
            syncIdsListObj.syncList = [{ id: matchingId, indexObj: moreContentFieldsType }];
        }
    }
};
export function* fetchContentEntry(data) {
    try {
        const { homeSyncIds, moreSyncIds } = data;
        let entriesList = [];
        homeSyncIds?.syncList?.forEach((syncListItem) => {
            entriesList.push(syncListItem?.id);
        });
        moreSyncIds?.syncList?.forEach((syncListItem) => {
            entriesList.push(syncListItem?.id);
        });
        if (entriesList?.length) {
            entriesList = Array.from(new Set(entriesList)); // to remove Duplicates
            const payload = { 'sys.id[in]': entriesList.toString(), include: '5' };
            const response = yield call(data?.contentClient?.getEntries, payload);
            if (response) {
                let updatedHomeResponse = yield updatedHomeResponseForReplacing(response, homeSyncIds);
                const userStatus = yield select((state) => state.appStateReducer.userStatus);
                if (updatedHomeResponse?.hasRootChange) {
                    updatedHomeResponse = yield determineContentfulDataForUserType(userStatus, updatedHomeResponse);
                }
                let updatedMoreResponse = yield updatedMoreResponseForReplacing(response, moreSyncIds);
                yield put({
                    type: CONTENTFUL_ENTRY_SUCCESS,
                    updatedHomeResponse,
                    updatedMoreResponse,
                });
            }
        }
        else {
            yield put({
                type: CONTENTFUL_ENTRY_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: CONTENTFUL_ENTRY_FAILURE,
        });
    }
}
export const updatedHomeResponseForReplacing = (response, homeSyncIds) => {
    let hasRootChange = false;
    let homeResponse = response?.items?.filter((content) => {
        for (let i = 0; i < homeSyncIds?.syncList?.length; i++) {
            if (homeSyncIds.syncList[i].id === get(content, sysId)) {
                content.index = homeSyncIds?.syncList[i]?.index;
                if (homeSyncIds?.syncList[i]?.index === -1) {
                    hasRootChange = true;
                }
                return true;
            }
        }
        return false;
    });
    let updatedHomeResponse = { homeResponse: homeResponse };
    updatedHomeResponse.hasRootChange = hasRootChange;
    return updatedHomeResponse;
};
export const updatedMoreResponseForReplacing = (response, moreSyncIds) => {
    let hasMoreRootChange = false;
    let moreResponse = response?.items?.filter((content) => {
        for (let i = 0; i < moreSyncIds?.syncList?.length; i++) {
            if (moreSyncIds.syncList[i].id === get(content, sysId)) {
                content.indexObj = moreSyncIds?.syncList[i]?.indexObj;
                if (moreSyncIds?.syncList[i]?.indexObj === '') {
                    hasMoreRootChange = true;
                }
                return true;
            }
        }
        return false;
    });
    let updatedMoreResponse = { moreResponse: moreResponse };
    updatedMoreResponse.hasMoreRootChange = hasMoreRootChange;
    return updatedMoreResponse;
};
export const determineContentfulDataForUserType = (userStatus, homeResponse) => {
    let result = homeResponse;
    if (userStatus.loggedIn && userStatus.localized) {
        return {
            ...result,
            newHomeContentfulResp: result?.homeResponse[0]?.fields?.localizedAuthenticated,
        };
    }
    else if (userStatus.loggedIn && !userStatus.localized) {
        return {
            ...result,
            newHomeContentfulResp: result?.homeResponse[0]?.fields?.nonlocalizedauthenticated,
        };
    }
    else if (!userStatus.loggedIn && !userStatus.localized) {
        return {
            ...result,
            newHomeContentfulResp: result?.homeResponse[0]?.fields?.nonlocalizedguest,
        };
    }
    else {
        return {
            ...result,
            newHomeContentfulResp: result?.homeResponse[0]?.fields?.localizedguest,
        };
    }
};
export function* fetchContentEntrySaga() {
    yield takeLatest(CONTENTFUL_ENTRY, fetchContentEntry);
}
